export default __webpack_public_path__ + "assets/images/Cross5LI-cd14c05b5a92ce490d9da50785aefe0c.jpg";